<div fxLayout="column" fxLayoutAlign="space-between stretch" fxLayoutGap="10px">
	<div
		fxFlex="60%"
		id="primary"
		class="ui segment"
		[ngClass]="{ loading: pending }"
	>
		<div appMargin marginB="4">
			<div class="text-center">
				<svg
					width="40"
					height="40"
					viewBox="0 0 40 40"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<circle cx="20" cy="20" r="20" fill="white" />
					<path
						d="M26.3655 14.4552L17.6356 23.2476L13.6345 19.2178C13.0319 18.6109 12.0547 18.6108 11.452 19.2177C10.8493 19.8247 10.8493 20.8087 11.452 21.4157L16.5443 26.5447C16.8337 26.8362 17.2262 27 17.6355 27C17.6356 27 17.6355 27 17.6356 27C18.0448 27 18.4373 26.8362 18.7267 26.5448L28.548 16.6534C29.1507 16.0464 29.1507 15.0623 28.548 14.4553C27.9453 13.8483 26.9682 13.8482 26.3655 14.4552Z"
						fill="#3F4395"
					/>
				</svg>
			</div>
			<div class="ui mini form" [formGroup]="form">
				<div class="fields">
					<div class="ten wide field">
						<h4>Invoice</h4>
					</div>
					<div class="six wide field text-center">
						<div class="ui dropdown" suiDropdown>
							<div class="text" style="text-transform: capitalize">
								{{ selectedType }}
							</div>
							<i class="dropdown icon"></i>
							<div class="menu" suiDropdownMenu>
								<div class="item" (click)="changeType('day')">Daily</div>
								<div class="item" (click)="changeType('month')">Monthly</div>
								<div class="item" (click)="changeType('year')">Yearly</div>
								<div class="item" (click)="changeType('all')">All time</div>
							</div>
						</div>
					</div>
				</div>
				<!-- <div class="inline  fields">
                                <label>Display</label>
                                <div class="field"  (click)="changeType('day')" >
                                    <sui-radio-button name="example" value="day" formControlName="type" [(ngModel)]="selectedType">Daily</sui-radio-button>

                                </div>
                                <div class="field"   (click)="changeType('month')" >
    <sui-radio-button name="example" value="month" formControlName="type" [(ngModel)]="selectedType">Monthly</sui-radio-button>
                                </div>
                                <div class="field"   (click)="changeType('year')" >
                                        <sui-radio-button name="example" value="year" formControlName="type" [(ngModel)]="selectedType">Yearly</sui-radio-button>
                                </div>
                            </div> -->

				<div class="two fields">
					<div class="field">
						<label class="text">From Date</label>
						<div class="ui right icon input">
							<i class="calendar icon"></i>
							<input
								suiDatepicker
								[attr.disabled]="isAll == true ? 'disabled' : null"
								[pickerMode]="mode"
								(pickerSelectedDateChange)="fromDate($event)"
								formControlName="from"
								[pickerUseNativeOnMobile]="false"
							/>
						</div>
					</div>
					<div class="field">
						<label class="text">To Date</label>
						<div class="ui right icon input">
							<i class="calendar icon"></i>
							<input
								suiDatepicker
								[attr.disabled]="isAll == true ? 'disabled' : null"
								[pickerMode]="mode"
								formControlName="to"
								(pickerSelectedDateChange)="toDate($event)"
								[pickerUseNativeOnMobile]="false"
							/>
						</div>
					</div>
				</div>
			</div>

			<!-- <div   appMargin marginY="2" fxLayout="row"   fxLayoutAlign='start stretch' fxLayoutGap="10px" >
					<div fxFlex>Invoice</div>
					<div fxFlex class="text-right">

						<div class="ui dropdown" suiDropdown>
								<div class="text">Year</div>
								<i class="dropdown icon"></i>
								<div class="menu" suiDropdownMenu>
									<div class="item">2015 to 2021</div>
								</div>
							</div>
					</div>
				</div> -->

			<div class="text-center">
				<!-- <div class="ui dropdown" suiDropdown >
								<div class="text">
								<svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M12.2959 4.51855H14.1943V5.9248H12.2959V7.25195H14.1943V8.6582H12.2959V13H10.0723L7.33887 8.6582H4.35938V13H2.14453V8.6582H0.290039V7.25195H2.14453V5.9248H0.290039V4.51855H2.14453V0.203125H4.35938L7.0752 4.51855H10.0898V0.203125H12.2959V4.51855ZM8.78906 7.25195H10.0898V5.9248H7.9541L8.78906 7.25195ZM4.35938 7.25195H6.45117L5.61621 5.9248H4.35938V7.25195ZM10.0898 9.31738V8.6582H9.67676L10.0898 9.31738ZM4.35938 4.51855H4.7373L4.35938 3.9209V4.51855Z" fill="#4BBEFF"/>
								</svg>
								</div>
								<i class="dropdown icon"></i>
								<div class="menu" suiDropdownMenu>
									<div class="item">2015 to 2021</div>
								</div>
					</div> -->

				<sui-select
					style="color: #4bbeff"
					placeholder="#"
					[(ngModel)]="currency"
					(ngModelChange)="selectedCurr()"
				>
					<sui-select-option
						*ngFor="let currency of currencies"
						[value]="currency.currencyCode"
					>
					</sui-select-option>
				</sui-select>

				<h3 appMargin marginY="2" style="font-size: 22px; font-weight: 500">
					{{ currency }} {{ invoiceDetail?.totalIssuedAmount | number: ".2-2" }}
				</h3>
				<small appMargin marginB="2">Issued Invoice Amount</small>
			</div>
		</div>
		<div id="inner" appPadding="3">
			<div fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="10px">
				<div fxFlex="grow">
					<h3 appMargin="0" style="font-size: 16px; font-weight: 500">
						{{ currency }}
						{{ invoiceDetail?.paidInvoiceAmount | number: ".2-2" }}
					</h3>
					<small>Paid Invoice Amount</small>
				</div>
				<div fxFlex class="text-right">
					<img src="./assets/icons/top.svg" />
				</div>
			</div>
			<div class="ui divider"></div>
			<div fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="10px">
				<div fxFlex="grow">
					<h3 appMargin="0" style="font-size: 16px; font-weight: 500">
						{{ currency }}
						{{ invoiceDetail?.outstandingInvoiceAmount | number: ".2-2" }}
					</h3>
					<small>Outstanding Invoice Amount</small>
				</div>
				<div fxFlex class="text-right">
					<img src="./assets/icons/down.svg" />
				</div>
			</div>
		</div>
	</div>
	<div
		style="color: #3f4395; font-size: 17px; margin-top: -1rem; font-weight: 500"
		class="ui header"
	>
		Invoice Summary
	</div>
	<div
		[ngClass]="{ loading: pending }"
		class="invoice-summary-count ui basic segment"
		appPadding="0"
		appMargin="0"
	>
		<div class="ui default message">
			<div>
				<div class="ui circular button">
					{{ invoiceDetail?.totalInvoices || 0 }}
				</div>
			</div>
			<span class="summary-text">Total Invoices</span>
		</div>
		<div class="ui default message">
			<div>
				<div class="ui circular button">
					{{ invoiceDetail?.fullyPaidInvoices || 0 }}
				</div>
			</div>
			<span class="summary-text">Fully Paid Invoices</span>
		</div>
		<div class="ui default message">
			<div>
				<div class="ui circular button">
					{{ invoiceDetail?.partlyPaidInvoices || 0 }}
				</div>
			</div>
			<span class="summary-text">Partly Paid Invoices</span>
		</div>
		<div class="ui default message">
			<div>
				<div class="ui circular button">
					{{ invoiceDetail?.unpaidInvoices || 0 }}
				</div>
			</div>
			<span class="summary-text">Unpaid Invoices</span>
		</div>
	</div>
	<!-- <div
    fxFlex="40%"
    id="primary"
    class="ui segment"
    appMargin
    marginB="4"
    appPadding
    paddingT="70px"
    style="display: inline-table"
  >
    <div class="text-center" appMargin marginB="60px">
      <div style="font-size: 32px; font-weight: 500" appMargin marginB="1">
        {{ invoiceDetail?.totalInvoices }}
      </div>
      <small appPadding paddingT="70px">Issued Invoice Count</small>
    </div>
    <div fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="10px">
      <div fxFlex class="text-center" id="inner" appPadding="3">
        <h3 appMargin marginB="1">Fully Paid</h3>
        <div>{{ invoiceDetail?.fullyPaidInvoices }}</div>
      </div>

      <div fxFlex class="text-center" id="inner" appPadding="3">
        <h3 appMargin marginB="1">Partly Paid</h3>
        <div>{{ invoiceDetail?.partlyPaidInvoices }}</div>
      </div>

      <div fxFlex class="text-center" id="inner" appPadding="3">
        <h3 appMargin marginB="1">Unpaid</h3>
        <div>{{ invoiceDetail?.unpaidInvoices }}</div>
      </div>
    </div>
  </div> -->
</div>
